var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 175.59 35.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-7{fill:#fffffe;}.cls-1{opacity:0.59;}.cls-1,.cls-2,.cls-3,.cls-4{isolation:isolate;}.cls-2{opacity:0.76;}.cls-3{opacity:0.46;}.cls-5{fill:#fff;}.cls-6{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon features") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1195",
    "data-name": "Ellipse 1195",
    className: "cls-1",
    cx: 57.37,
    cy: 10.91,
    r: 9.28
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1196",
    "data-name": "Ellipse 1196",
    className: "cls-2",
    cx: 65.46,
    cy: 25.1,
    r: 9.28
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1197",
    "data-name": "Ellipse 1197",
    className: "cls-3",
    cx: 49.42,
    cy: 25.1,
    r: 9.28
  })), /*#__PURE__*/React.createElement("g", {
    id: "T",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.36,35.09H8.62V8.94H0V3.33H24V8.94H15.36Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4369",
    "data-name": "Path 4369",
    className: "cls-5",
    d: "M99.13,18.4H119s1.47,11.39-9.93,11.39S99.13,18.4,99.13,18.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1192",
    "data-name": "Ellipse 1192",
    className: "cls-6",
    cx: 109.29,
    cy: 17.43,
    r: 16.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1193",
    "data-name": "Ellipse 1193",
    className: "cls-5",
    cx: 114.6,
    cy: 11.31,
    rx: 2.44,
    ry: 3.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1194",
    "data-name": "Ellipse 1194",
    className: "cls-5",
    cx: 103.23,
    cy: 11.31,
    rx: 2.44,
    ry: 3.09
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4370",
    "data-name": "Path 4370",
    className: "cls-7",
    d: "M167.74,35.47H148a7.85,7.85,0,0,1-7.84-7.85V9.17A7.85,7.85,0,0,1,148,1.32h19.73a7.87,7.87,0,0,1,7.85,7.85V27.62A7.87,7.87,0,0,1,167.74,35.47ZM148,2.5a6.67,6.67,0,0,0-6.66,6.67V27.62A6.67,6.67,0,0,0,148,34.29h19.73a6.68,6.68,0,0,0,6.67-6.67V9.17a6.69,6.69,0,0,0-6.67-6.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1198",
    "data-name": "Ellipse 1198",
    className: "cls-7",
    cx: 149.19,
    cy: 10.21,
    rx: 3.72,
    ry: 3.59
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4371",
    "data-name": "Path 4371",
    className: "cls-7",
    d: "M149.19,14.08a3.88,3.88,0,1,1,4-3.87A4,4,0,0,1,149.19,14.08Zm0-7.17a3.3,3.3,0,1,0,3.43,3.3,3.37,3.37,0,0,0-3.43-3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4372",
    "data-name": "Path 4372",
    className: "cls-7",
    d: "M161.86,16.35l-3.16,5.26a1,1,0,0,1-1.34.31,1,1,0,0,1-.31-.31h0a3.71,3.71,0,0,0-5.12-1.19,3.79,3.79,0,0,0-1.2,1.19l-4.8,8h23.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4373",
    "data-name": "Path 4373",
    className: "cls-7",
    d: "M170.29,29.89H145.46l5-8.41A4,4,0,0,1,156,20.19a3.79,3.79,0,0,1,1.29,1.29.74.74,0,0,0,1,.17,1.37,1.37,0,0,0,.17-.17l3.39-5.65Zm-23.89-.53h22.95l-7.49-12.49-2.93,4.88a1.24,1.24,0,0,1-2.11,0,3.46,3.46,0,0,0-5.86,0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatures);
export default __webpack_public_path__ + "static/media/iconFeatures.50c07118eb40bea041a3f22b9189e2c9.svg";
export { ForwardRef as ReactComponent };